export default "__VITE_ASSET__C5UzPBPU__"